// extracted by mini-css-extract-plugin
export default {"bar":"_35c61a57","stickyBar":"_7351e528","barContent":"_3d0d9d5e","leftContainer":"_2194035a","rightContainer":"_2e35ec41"};